export const StorageKey = {
    USER_DETAIL: "userDetails",
};
